<template>
  <v-layout
    row
    fill-height
    align-center
    justify-center
  >
    <v-flex shrink>
      <v-progress-circular
        :size="120"
        color="sz_red"
        indeterminate
      />
      <AppLogo
        width="44"
        class="relative-to-progress"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import AppLogo from '@/components/widgets/AppLogo';
export default {
    name: 'PageLoader',
    components: { AppLogo }
};
</script>

<style lang="scss" scoped>
.relative-to-progress {
  position: relative;
  transform: translate(-50%, 0);
  left: 50%;
  top: -82px;
}
</style>
